<div role="banner" class="container row">
  <ds-header-navigation
    class="column none lg-block lg-twelve"
    [class.logged-in]="loggedIn()"
    [loaded$]="loaded$()"
    [headerLogo]="headerLogo()"
    [brandInfo]="brandInfo()"
    [linkArray]="linkArray()"
    [notifications]="notifications()"
    [homeUrl]="homeUrl()"
    [loggedIn]="loggedIn()"
    [contactDetails]="contactDetails()"
    (linkClickEvent)="linkClicked($event)"
    (sublinkClickEvent)="sublinkClicked($event)"
    [dsInternalLinkClick]="internalLinkClickObject()"
  ></ds-header-navigation>
  <ds-header-mobile-navigation
    class="column twelve block lg-none"
    [class.logged-in]="loggedIn()"
    [loaded$]="loaded$()"
    [headerLogo]="headerLogo()"
    [brandInfo]="brandInfo()"
    [linkArray]="linkArray()"
    [notifications]="notifications()"
    [homeUrl]="homeUrl()"
    [loggedIn]="loggedIn()"
    (linkClickEvent)="linkClicked($event)"
    (sublinkClickEvent)="sublinkClicked($event)"
  ></ds-header-mobile-navigation>
</div>
